import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import imageCompression from 'browser-image-compression';

const OrderEntry = () => {
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);  // Loading state

  const isAuthenticated = localStorage.getItem('userToken'); // Check login token
  // useEffect(() => {
  //   const isAuthenticated = localStorage.getItem('userToken'); // Check login token
  //   if (!isAuthenticated) {
  //     navigate('/signin'); // Redirect to SignIn if not logged in
  //   }
  // }, [navigate]);


  // const handleOrderSubmit = async (event) => {
  //   event.preventDefault();
  //   const formData = new FormData(event.target);
  //   const response = await fetch('https://api.ninjabakers.com/baker/api/orders', {
  //     method: 'POST',
  //     body: formData,
  //   });

  //   if (response.ok) {
  //     setMessage('Order placed successfully!');
  //   } else {
  //     setMessage('Failed to place the order.');
  //   }
  // };

  // const handleOrderSubmit = async (event) => {
  //   event.preventDefault();
  //   const formData = new FormData(event.target);
  //   const file = formData.get('file');

  //   // Check if file is selected
  //   if (!file || file.size === 0) {
  //     setMessage('Please select a valid file.');
  //     return;
  //   }

  //   setLoading(true); // Start loading indicator

  //   try {
  //     const response = await fetch('https://api.ninjabakers.com/baker/api/orders', {
  //       method: 'POST',
  //       body: formData,
  //     });

  //     if (response.ok) {
  //       setMessage('Order placed successfully!');
  //     } else {
  //       const errorText = await response.text();
  //       setMessage(`Failed to place the order. ${errorText}`);
  //     }
  //   } catch (error) {
  //     setMessage(`Error: ${error.message}`);
  //   } finally {
  //     setLoading(false); // Stop loading
  //   }
  // };
  const handleOrderSubmit = async (event) => {
    event.preventDefault();
    // alert('Submit button clicked! ✅');

    const formData = new FormData(event.target);
    let file = formData.get('file');

    if (!file || file.size === 0) {
      setMessage('Please select a valid file.');
      return;
    }

    // alert(`Original File Size: ${file.size / 1024} KB`);

    // 1️⃣ Compress the image if size > 1MB
    if (file.size > 1024 * 1000) { // >1MB
      try {
        const options = {
          maxSizeMB: 0.5,       // Compress to 500 KB
          maxWidthOrHeight: 1024,
          useWebWorker: true,
        };
        file = await imageCompression(file, options);
        // alert(`Compressed File Size: ${(file.size / 1024).toFixed(2)} KB`);
      } catch (error) {
        // alert(`Compression Error: ${error.message}`);
      }
    }

    // 2️⃣ Send the compressed file
    const compressedFormData = new FormData();
    compressedFormData.append('file', file);

    try {
      // alert('Uploading image... 📤');

      const response = await fetch('https://api.ninjabakers.com/baker/api/orders', {
        method: 'POST',
        body: compressedFormData,
      });

      if (response.ok) {
        //  alert('🎉 Order placed successfully!');
        setMessage('🎉 Order placed successfully!');
      } else {
        const errorText = await response.text();
        setMessage(`Failed to place the order. ${errorText}`);
        // alert(`❌ Failed to place the order.\nServer Response: ${errorText}`);
      }
    } catch (error) {
      //alert(`🚨 Error Occurred: ${error.message}`);
      setMessage(`Error: ${error.message}`);
    }
    finally {
      setLoading(false); // Stop loading
    }
  };



  return (
    <div className="p-4">
      <h1 className="text-xl mb-4">Place Order</h1>
      <form onSubmit={handleOrderSubmit}>
        <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-2">
          <input type="file" name="file" accept="image/*" required className="p-2 border rounded-md" />
          <button
            type="submit"
            className={`bg-green-500 text-white p-2 rounded-md w-full md:w-auto ${loading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            disabled={loading}
          >
            {loading ? 'Submitting...' : 'Submit Order'}
          </button>
        </div>
      </form>

      <button
        className="bg-blue-500 text-white px-4 py-2 rounded-md mt-4"
        onClick={() => navigate('/orders-list')}
      >
        View Existing Orders
      </button>

      {message && (
        <div className="mt-4 bg-blue-100 text-blue-800 p-4 rounded-md shadow-md">
          <p>{message}</p>
          <button
            onClick={() => navigate('/orders-list')}
            className="bg-blue-500 text-white px-4 py-2 rounded-md mt-2 hover:bg-blue-600"
          >
            View Orders
          </button>
        </div>
      )}
    </div>
  );
};

export default OrderEntry;